import { render, staticRenderFns } from "./EstimageMessageListView.vue?vue&type=template&id=53400f7d&scoped=true"
import script from "./EstimageMessageListView.vue?vue&type=script&lang=js"
export * from "./EstimageMessageListView.vue?vue&type=script&lang=js"
import style0 from "./EstimageMessageListView.vue?vue&type=style&index=0&id=53400f7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53400f7d",
  null
  
)

export default component.exports